<div class="image-preview-wrapper">
  <div class="image-frame bg-transparency-checker">
    <img [alt]="alt()" [src]="effectiveUrl()" />
  </div>
</div>
